module.exports = __webpack_public_path__ + "img/undraw_business_deal_re_up4u.77cd13e9.svg";